// The 4 fixed-order section ids the UW contract validates `sections[]` against.
export const RECON_SECTION_ID = {
    REVENUE_WORKING_CAPITAL: 'revenueWorkingCapital',
    BANK_ACCOUNTS_CASH_FLOW: 'bankAccountsCashFlow',
    DEBT_SANCTION_REPAYMENTS: 'debtSanctionRepayments',
    CAPITAL_RESERVES: 'capitalReserves',
} as const;

// The 3 drill-down-capable recon ids — the only ids `drillDown.reconId` accepts.
export const RECON_DRILLDOWN_IDS = ['revenue', 'vendorPayments', 'newSanctions'] as const;

// The 11 recon ids the UW contract emits across all sections.
export const RECON_ID = {
    REVENUE: 'revenue',
    VENDOR_PAYMENTS: 'vendorPayments',
    ACCOUNT_RECEIVABLES: 'accountReceivables',
    ACCOUNT_PAYABLES: 'accountPayables',
    BANK_BALANCE: 'bankBalance',
    CASH_BURN: 'cashBurn',
    EPF_STATUTORY_DUES: 'epfStatutoryDues',
    DEBT: 'debt',
    NEW_SANCTIONS: 'newSanctions',
    NET_WORTH: 'netWorth',
    EQUITY: 'equity',
} as const;

// Redux cache key for the page-load request (fys: null) — the server picks the latest 3
// audited FYs, and the response's own `fys` maps back to this key (no refetch on drawer open).
export const DEFAULT_FY_KEY = 'default';

export const fyKey = (fys: number[] | null | undefined): string =>
    !fys || fys.length === 0 ? DEFAULT_FY_KEY : [...fys].sort((a, b) => a - b).join(',');

export const drillDownKey = (reconId: string, fy: number): string => `${reconId}:${fy}`;

export const DATA_AVAILABILITY_WINDOW_LAST_12M = 'LAST_12M';

export const PERIOD_IDS = { LAST_FY: 'LAST_FY', LAST_12M: DATA_AVAILABILITY_WINDOW_LAST_12M, CURRENT_FY: 'CURRENT_FY' } as const;

/** Redux cache key for one Data Availability period: `${orgId}|${fy ?? window}`. */
export const availabilityKey = (orgId: string, fy: number | null, window: string | null): string => `${orgId}|${fy ?? window}`;

// Transcribed from aica CommonConstants.GST_STATE_MAP — the fallback for a roster row that carries no `state`.
export const GST_STATE_BY_CODE: Record<string, string> = {
    '01': 'JAMMU AND KASHMIR',
    '02': 'HIMACHAL PRADESH',
    '03': 'PUNJAB',
    '04': 'CHANDIGARH',
    '05': 'UTTARAKHAND',
    '06': 'HARYANA',
    '07': 'DELHI',
    '08': 'RAJASTHAN',
    '09': 'UTTAR PRADESH',
    '10': 'BIHAR',
    '11': 'SIKKIM',
    '12': 'ARUNACHAL PRADESH',
    '13': 'NAGALAND',
    '14': 'MANIPUR',
    '15': 'MIZORAM',
    '16': 'TRIPURA',
    '17': 'MEGHALAYA',
    '18': 'ASSAM',
    '19': 'WEST BENGAL',
    '20': 'JHARKHAND',
    '21': 'ODISHA',
    '22': 'CHATTISGARH',
    '23': 'MADHYA PRADESH',
    '24': 'GUJARAT',
    '26': 'DADRA AND NAGAR HAVELI AND DAMAN AND DIU',
    '27': 'MAHARASHTRA',
    '28': 'ANDHRA PRADESH',
    '29': 'KARNATAKA',
    '30': 'GOA',
    '31': 'LAKSHADWEEP',
    '32': 'KERALA',
    '33': 'TAMIL NADU',
    '34': 'PUDUCHERRY',
    '35': 'ANDAMAN AND NICOBAR ISLANDS',
    '36': 'TELANGANA',
    '37': 'ANDHRA PRADESH',
    '38': 'LADAKH',
    '97': 'OTHER TERRITORY',
    '99': 'CENTRE JURISDICTION',
};

// How many recent FYs (current included) the Data Availability dropdown and the drawer's Financial Year multiselect list.
export const RECENT_FY_OPTION_COUNT = 5;
